import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { ThreadListDefaultView } from './views/ThreadListDefaultView';
import { DefaultView, Views } from '../../types/BlockWithViews';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { ThreadListInteractions } from './partials/ThreadListInteractions';
import { ThreadListEditDefaultView } from './views/ThreadListEditDefaultView';

type ThreadListBlockBlockProps = Views<DefaultView<ThreadListDefaultView | ThreadListEditDefaultView>>;
function ThreadList({ views, activeView = 'default' }: ThreadListBlockBlockProps) {
  // return <ThreadListDefaultView {...views.default} />;

  const { editModeInfo } = useAppContext();
  const { active } = editModeInfo;
  switch (active) {
    case true:
      // EditMode
      return <ThreadListInteractions views={views} activeView={activeView} />;
    default:
      // LiveMode:
      return <ThreadListDefaultView {...(views.default as ThreadListDefaultView)} />;
  }
}

export const ThreadListBlock = asFetchableBlock(ThreadList, BlockType.threadlist);
export type ThreadListBlock = ComponentProps<typeof ThreadList>;
